/**
 * @generated SignedSource<<2ff206ebda9a705400bfa93f15db0e6c>>
 * @relayHash 47b6bed432e93d293b71d554de9d22cf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8e6818c1b5edb7793a16ffa9f89aef19e1986ebf11c163e4b84b6c6c60cf8d8d

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { EntryPointContentQuery } from './EntryPointContentQuery.graphql';

const node: PreloadableConcreteRequest<EntryPointContentQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "8e6818c1b5edb7793a16ffa9f89aef19e1986ebf11c163e4b84b6c6c60cf8d8d",
    "metadata": {},
    "name": "EntryPointContentQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
